import { render, staticRenderFns } from "./EnacProcedureAtpDafGroupWidget.vue?vue&type=template&id=3d31bb6b"
import script from "./EnacProcedureAtpDafGroupWidget.vue?vue&type=script&lang=js"
export * from "./EnacProcedureAtpDafGroupWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports